import { ActionMap } from '@/components/forms/FormContext';
import { RepairFormState } from '../../constants';

// Enum of all your possible actions
export const SystemAgeStepActions = {
	UPDATE_SYSTEM_AGE: 'UPDATE_SYSTEM_AGE',
} as const;
// The type for the enum
export type SystemAgeStepAction = keyof typeof SystemAgeStepActions;

// Payloads for each action
export interface SystemAgeStepActionPayload {
	[SystemAgeStepActions.UPDATE_SYSTEM_AGE]: string;
}

// Discriminated union of all possible actions with their corresponding payloads
export type SystemAgeStepActionMap =
	ActionMap<SystemAgeStepActionPayload>[keyof ActionMap<SystemAgeStepActionPayload>];

// A check for if the action is in this step's enum
export const isSystemAgeStepActionMap = (
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	action: any,
): action is SystemAgeStepActionMap => action.type in SystemAgeStepActions;

// The reducer for this step, this needs to return the new state, with the new values
export const systemAgeStepReducer = (
	state: RepairFormState,
	action: SystemAgeStepActionMap,
): RepairFormState => {
	switch (action.type) {
		case SystemAgeStepActions.UPDATE_SYSTEM_AGE:
			return {
				...state,
				systemAge: action.payload,
			};
		default:
			return state;
	}
};

// A check for if the form is valid, the useValidateStep hook will use this to
// determine if the step is and the user can continue / submit
export const isValid = (state: RepairFormState): boolean => {
	const { systemAge } = state;
	return !!systemAge;
};
